import { render, staticRenderFns } from "./GroupDownlinksQueueSection.vue?vue&type=template&id=7b2897c9&scoped=true&"
import script from "./GroupDownlinksQueueSection.vue?vue&type=script&lang=ts&"
export * from "./GroupDownlinksQueueSection.vue?vue&type=script&lang=ts&"
import style0 from "./GroupDownlinksQueueSection.vue?vue&type=style&index=0&id=7b2897c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2897c9",
  null
  
)

export default component.exports